<template>
    <div class="pay-channel-list">
        <!-- <div class="row">
            <pay-channel-item
                v-for="item in outerPayChannels"
                :key="item.channel"
                :checked="value === item.channel"
                :show-radio="showRadio"
                :pay-channel="item.channel"
                :disabled="item.disabled"
                @change="handleChange"
            />
        </div> -->
        <div class="row">
            <pay-channel-item
                v-for="item in payChannels"
                :key="item"
                :checked="value === item"
                :show-radio="showRadio"
                :pay-channel="item"
                @change="handleChange"
            />
        </div>
    </div>
</template>

<script>
import PayChannelItem from './components/pay-channel-item';
export default {
    name: 'SyPayChannelListNew',
    components: {
        PayChannelItem
    },
    props: {
        // 所有支付渠道
        payChannels: {
            type: Array,
            default: () => ['UNION_CHANGE', 'JSB_WALLET', 'JSB_FINANCING', 'CREDIT']
        },
        // 是否显示单选框
        showRadio: {
            type: Boolean,
            default: true
        },
        // 当前支付渠道
        value: {
            type: String,
            default: ''
        }
    },
    methods: {
        /**
         * 处理点击事件
         */
        handleChange(event) {
            this.$emit('input', event);
        }
    }
};
</script>

<style lang="scss" scoped>
.pay-channel-list {
    .row {
        display: flex;
        flex-wrap: wrap;
    }

    .pay-channel-item {
        margin: 0 23px 23px 0;
    }
}

@media only screen and (max-width: 800px) {
    .pay-channel-list {
        min-width: 200px;
    }
}
</style>
